<template>
  <div class="camsContainer">
    <div class="nonGraphContainer">
      <div class="pageHeader">
        <ContentHeader :name=this.headerName :subHeader="subHeader" :route="subPage" />
        <!-- <button @click="(event) => handleButtonPress(event)">Add Vehicle</button> -->
      </div>
    </div>
    <div class="currentView">
      <!-- These selectors should probably be their own component -->
      <div>
        <div class="dataTableSelectorGroup">
          <div class="dataTableSelector" id="filtersModal">
            <SearchBar v-bind:search="search" v-bind:searchCallback="(data) => { this.performSearch(data) }"
              :searchIcon="true">
            </SearchBar>
          </div>
        </div>
        <DataTable v-bind:tableData="usersTableData" v-bind:configuration="users" v-bind:search="search"
          v-bind:openModalCallback="function () { handleModal(users); }" :headers="headers" />

        <AnalyticsGraph title="At a Glance" v-bind:configuration="users" />
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from "../../ContentHeader.vue";
import * as Constants from "../../../js/constants";
//import EventBus from "../../../eventBus";
import DataTable from "../pageComps/DataTable.vue";
import SearchBar from "../pageComps/Search.vue";
import CTSRepository from "../../../js/CTSRepository";

export default {
  name: "VehiclesPage",
  props: ["subPage", "organizationData"],
  components: {
    ContentHeader,
    DataTable,
    SearchBar
  },
  data() {
    return {
      selectedItem: Constants.GATE,
      headerName: Constants.USERS,
      subHeader: "Below is a list of all vehicles registered in your community!",
      filterStartDate: null,
      filterEndDate: null,
      defaultStartDate: null,
      defaultEndDate: null,
      filters: [],
      usersTableData: [],
      tableData: [],
      search: "",
      users: Constants.USERS,
      cardInfo: Constants.DEFAULT_CARD_INFO,
      headers: [
        { text: "Make", value: "manufacturer", align: "start", sortable: true, width: 300 },
        { text: "Model", value: "model", filterable: true, width: 175 },
        { text: "Color", value: "color", width: 175 },
        { text: "Year", value: "year", filterable: false, width: 180 },
        { text: "License Plate", value: "license_plate_number", filterable: false, width: 180 },
        { text: "State", value: "state_of_issuance", filterable: false, width: 175 },
        { text: "Transponder ID", value: "rfid_transponder_number", filterable: false, width: 180 },
        { text: "Decal Number", value: "decal_number", filterable: false, width: 180 },
        { text: "Current Status", value: "current_status", filterable: false, width: 180 },
        { text: "Resident", value: "resident_uid", filterable: false, width: 180 }
      ]
    };
  },
  created() {
    var date = new Date();
    this.defaultEndDate = date.toISOString().split('T')[0]
    var startDate = new Date(date)
    startDate.setDate(date.getDate() - 7);
    //this.defaultStartDate = startDate.toISOString().split('T')[0]
    this.defaultStartDate = "2019-06-06"
    this.performSearch("").then((apiData) => {
      console.log("Finished getting and setting API Data", apiData);
    });
  },
  watch: {
    organizationData: function (newVal) {
      if (newVal != null) {
        this.performSearch(this.search).then((apiData) => {
          console.log("Finished getting and setting API Data", apiData);
        });
      }
    }
  },
  methods: {
    openGateFiletersModal() {
      console.log("Opening Gate Filters Modal")
    },
    homeChangeText() {
      console.log("Home knows the button was clicked");
    },
    performSearch(data) {
      if (this.$props.organizationData == null || this.$props.organizationData == undefined) return
      this.search = data
      new CTSRepository(this.$props.organizationData).fetchVehicles(data)
        .then((data) => {
          console.log("Search Data", data);
          this.usersTableData = data.data
        })
        .catch((err) => {
          console.log("Error fetching vehicles", err)
        });
    },
    openGateModal() {
      this.$modal.show("gate-modal");
    },
    openUsersModal() {
      this.$modal.show("users-modal");
    },
    handleModal(configuration) {
      switch (configuration) {
        case Constants.GATE: {
          this.openGateModal();
          break;
        }
        case Constants.INCIDENTS: {
          console.log("Opening Incidents Modal");
          break;
        }
        case Constants.USERS: {
          this.openUsersModal()
          break;
        }
      }
    },
    handleButtonPress() {
      this.$modal.show(Constants.CREATE_VEHICLE_MODAL)
    }
  },
};
</script>

<style scoped>
.dataTableSelectorGroup {
  display: flex;
  widows: 100%;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 16px;
}

.dataTableSelector:nth-child(3n) {
  margin-right: 0px;
}

.selectorContent {
  width: 100%;
  color: white;
  font-size: 28px;
  display: inline;
  margin-right: 16px;
}

.selectorContent::placeholder {
  width: 100%;
  color: white;
  font-size: 28px;
}

.pageHeader button {
  background-color: #1890FFCC;
  color: white;
}

.filterIcon {
  margin-right: 16px;
  display: inline;

}

.iconGroup {
  display: inline;
}
</style>